import { FormattedMessage } from 'react-intl';

import { useVersionBadge } from './version-badge.controller';

const VersionBadge = () => {
    const viewProps = useVersionBadge();

    return (
        <div className='relative inline-flex flex-col items-center justify-center'>
            <button
                type='button'
                className='text-foreground-muted hover:text-foreground-default cursor-pointer text-xs font-light transition-colors select-none'
                onClick={viewProps.togglePopover}>
                {viewProps.versionNumber}
            </button>

            {viewProps.popoverOpen && (
                <>
                    <div
                        className='fixed inset-0 z-40'
                        onClick={viewProps.closePopover}
                    />
                    <div className='bg-background-surface border-border-default absolute bottom-full z-50 mb-2 flex min-w-56 flex-col gap-2 rounded-xl border p-4 shadow-lg'>
                        <p className='text-foreground-default text-xs font-semibold'>
                            <FormattedMessage
                                id='version-badge.title'
                                defaultMessage='Version info'
                                description='Title of the version info popover'
                            />
                        </p>
                        <div className='flex flex-col gap-1'>
                            <VersionRow
                                label={
                                    <FormattedMessage
                                        id='version-badge.label.version'
                                        defaultMessage='Version'
                                        description='Version label in version info popover'
                                    />
                                }
                                value={viewProps.humanReadable}
                            />
                            <VersionRow
                                label={
                                    <FormattedMessage
                                        id='version-badge.label.number'
                                        defaultMessage='Number'
                                        description='Number label in version info popover'
                                    />
                                }
                                value={viewProps.versionNumber}
                            />
                            <VersionRow
                                label={
                                    <FormattedMessage
                                        id='version-badge.label.sha'
                                        defaultMessage='SHA'
                                        description='SHA label in version info popover'
                                    />
                                }
                                value={viewProps.uniqueSha}
                            />
                            <VersionRow
                                label={
                                    <FormattedMessage
                                        id='version-badge.label.released'
                                        defaultMessage='Released'
                                        description='Released label in version info popover'
                                    />
                                }
                                value={viewProps.releaseDate}
                            />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

const VersionRow = ({ label, value }: { label: React.ReactNode; value: string }) => (
    <div className='flex items-center justify-between gap-4'>
        <span className='text-foreground-muted text-xs'>{label}</span>
        <span className='text-foreground-default font-mono text-xs'>{value}</span>
    </div>
);

export default VersionBadge;
